import { useCallback, useState } from 'react'

export const useToggle = (defaultValue = false) => {
  const [state, setState] = useState<boolean>(defaultValue)

  const toggle = useCallback(() => {
    setState(curr => !curr)
  }, [])

  const smartSetState = useCallback(
    (newValue: boolean) => {
      if (newValue !== state) {
        setState(newValue)
      }
    },
    [state]
  )

  return [state, toggle, smartSetState] as const
}
